import React from 'react';
import { ResidencePage } from '../../components/Views/ResidencePage';
import { getSeoData } from '../../utils/helpers';
import { getCurrentResidenceQuery } from '../../api/queries';
import Layout from '../../components/Layout/Layout';
import initApollo from '../../utils/init-Apollo';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import { getStaticData } from '../../utils/helpers/getStaticData';
import { getResidenceMockData } from '../../utils/helpers/getResidenceMockData';
import { normalizeItemPagePath } from '../../utils/helpers/item';

const Residence = props => <ResidencePage {...props} />;

export async function getServerSideProps({ res, req, query }) {
  if (query.mock === 'true' && process.env.NODE_ENV !== 'production') {
    return getResidenceMockData();
  }

  res.setHeader(
    'Cache-Control',
    'public, max-age=300, s-maxage=300, stale-while-revalidate=86400'
  );
  const existingVary = res.getHeader('Vary');
  const vary = Array.isArray(existingVary)
    ? existingVary.join(', ')
    : existingVary || '';
  res.setHeader(
    'Vary',
    vary && !vary.includes('x-forwarded-host')
      ? `${vary}, x-forwarded-host`
      : vary || 'x-forwarded-host'
  );

  const apolloClient = initApollo({}, { lang: getLocaleOnSSR(req) });
  const asPath = normalizeItemPagePath(req.url);
  const residenceSlug = query.residence;

  try {
    const [seoData, residenceRes, staticData] = await Promise.all([
      getSeoData(apolloClient, asPath, req),
      apolloClient.query({
        query: getCurrentResidenceQuery,
        variables: { slug: residenceSlug },
        errorPolicy: 'all'
      }),
      getStaticData(apolloClient)
    ]);

    const residence = residenceRes?.data?.residence ?? null;
    if (!residence) {
      res.statusCode = 404;
    }

    return {
      props: {
        seoData,
        ...staticData,
        residence,
        residenceSlug,
        hasError: Boolean(residenceRes?.errors?.length),
        apolloCache: apolloClient.cache.extract()
      }
    };
  } catch {
    res.setHeader('Cache-Control', 'no-store');
    return {
      props: {
        seoData: {},
        keywords: [],
        citiesUnPopularList: [],
        regions: {},
        residence: null,
        hasError: true
      }
    };
  }
}

Residence.getLayout = (page, pageProps) => (
  <Layout
    isBottomNavigation={false}
    isShowBackButton
    isShowCloseButton={false}
    pageProps={pageProps}
  >
    {page}
  </Layout>
);

export default Residence;
